export default theme => ({
    Form: {
        position: 'relative',
        marginBottom: 36,
        '& .error': {
            backgroundColor: 'rgba(255, 0, 0, 0.2)'
        },
        '& .g-recaptcha': {
            display: 'flex',
            marginTop: 40,
            justifyContent: 'center',
            [theme.breakpoints.up('md')]: {
                justifyContent: 'flex-end',
            }
        }
    },
    Fields: {
        border: 'none',
        padding: 0,
        margin: 0,
    },
    Field: {

    },
    Label: {
        position: 'relative',
        display: 'block',
        fontSize: 14,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        letterSpacing: '0.06em',
        fontFamily: theme.headerFont,
        marginBottom: 3,
    },
    Input: {
        position: 'relative',
        border: 'none',
        borderBottom: '2px solid ' + theme.palette.primary.main,
        backgroundColor: 'white',
        fontSize: 12,
        fontFamily: theme.bodyFont,
        letterSpacing: '0.01em',
        padding: '15px 20px',
        height: 'auto !important',
        lineHeight: '1.2',
        '-webkit-appearance': 'none',
        '-mox-appearance': 'none',
        width: '100%',
        borderRadius: 0,
        overflow: 'hidden',
        backgroundColor: 'white',
        marginBottom: 12,
    },
    Option: {
        position: 'relative',
        display: 'block',
        width: '100%',
        paddingLeft: 36,
        fontSize: 14,
        lineHeight: '26px',
        letterSpacing: '0.032em',
        marginBottom: 16,
        marginTop: 16,
        color: theme.palette.common.white,
        [theme.breakpoints.up('md')]: {
            display: 'inline-block',
            marginRight: 32,
            fontSize: 14,
            color: theme.palette.common.black,
        },
        '& img': {
            display: 'inline-block',
            marginRight: 6,
            width: 25,
            verticalAlign: 'top',
            '&.light': {
                [theme.breakpoints.up('md')]: {
                    display: 'none',
                }
            },
            '&.dark': {
                display: 'none',
                [theme.breakpoints.up('md')]: {
                    display: 'inline-block',
                }
            }
        },
        '& input': {
            position: 'absolute',
            opacity: 0,
            cursor: 'pointer',
            width: 0,
            height: 0,
            margin: 0,
            top: 0,
            left: 0,
        },
        '& .checkmark': {
            position: 'absolute',
            cursor: 'pointer',
            top: 0,
            left: 0,
            height: 24,
            width: 24,
            backgroundColor: theme.palette.common.white,
            border: '1px solid ' + theme.palette.primary.main,
            '&::after': {
                content: '""',
                position: 'absolute',
                display: 'none',
                left: 7,
                top: 3,
                width: 5,
                height: 10,
                border: 'solid ' + theme.palette.primary.contrastText,
                borderWidth: '0 3px 3px 0',
                transform: 'rotate(45deg)',
                boxSizing: 'content-box',

            },
        },
        '&:hover input ~ .checkmark': {
            border: '1px solid ' + theme.palette.primary.dark,
        },
        '& input:checked ~ .checkmark': {
            backgroundColor: theme.palette.primary.main,
        },
        '& input:checked ~ .checkmark::after': {
            display: 'block',
        }
    },
    Submit: {
        display: 'block',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: 14,
        border: 'none',
        borderRadius: 4,
        textTransform: 'uppercase',
        fontSize: 16,
        fontWeight: 'bold',
        boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.1)',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        fontFamily: theme.headerFont,
        letterSpacing: '0.06em',
        lineHeight: 1.15,
        marginTop: 24,
        textAlign: 'left',
        marginBottom: 24,
        transition: 'background-color .3s ease-in-out',
        '&:hover, &:focus': {
            backgroundColor: '#72ce9b',
        },
        '& img': {
            marginTop: 2,
            width: 14,
            float: 'right',
            marginLeft: 20,
            verticalAlign: 'middle'
        },
        [theme.breakpoints.up('md')]: {
            marginBottom: 0,
            maxWidth: 240,
            float: 'right',
        }
    },
})
